import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "overflow-y-auto flex-1 print:overflow-hidden"
};
const _hoisted_2 = {
  class: "inline-block print:inline py-2 min-w-full align-middle"
};
const _hoisted_3 = {
  class: "bar-border-bottom border-gray-200 shadow"
};
const _hoisted_4 = {
  class: "min-w-full divide-y divide-gray-200"
};
const _hoisted_5 = {
  class: "divide-y divide-gray-200"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  class: "text-green-regular at-rate-card-default"
};
const _hoisted_8 = {
  class: "cursor-pointer"
};
export default {
  __name: 'InvoiceTemplateListTable',
  props: {
    invoiceTemplateLists: {
      type: Object,
      required: true
    },
    items: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_row = _resolveComponent("v-row");
      const _component_v_list_item_title = _resolveComponent("v-list-item-title");
      const _component_v_list_item = _resolveComponent("v-list-item");
      const _component_v_list = _resolveComponent("v-list");
      const _component_v_menu = _resolveComponent("v-menu");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("table", _hoisted_4, [_cache[1] || (_cache[1] = _createElementVNode("thead", null, [_createElementVNode("tr", null, [_createElementVNode("th", {
        class: "sticky top-0 py-4 px-6 print:px-1 text-xs font-medium tracking-wider text-left text-gray-500 uppercase bg-gray-50"
      }, " Name "), _createElementVNode("th", {
        class: "sticky top-0 py-4 px-6 print:px-1 text-xs font-medium tracking-wider text-left text-gray-500 uppercase bg-gray-50"
      })])], -1)), _createElementVNode("tbody", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.invoiceTemplateLists, (invoiceTemplate, idx) => {
        return _openBlock(), _createElementBlock("tr", {
          key: idx,
          "data-cy": "invoice-template-table"
        }, [_createElementVNode("td", {
          class: "py-3 px-6 cursor-pointer",
          "data-cy": "invoice-template-name",
          onClick: _withModifiers($event => _ctx.$emit('updateInvoiceTemplate', invoiceTemplate.invoiceTemplateId, invoiceTemplate), ["prevent"])
        }, [_createTextVNode(_toDisplayString(invoiceTemplate.name) + " ", 1), _withDirectives(_createElementVNode("span", _hoisted_7, "(Default)", 512), [[_vShow, invoiceTemplate.default]])], 8, _hoisted_6), _createElementVNode("td", _hoisted_8, [_createVNode(_component_v_menu, null, {
          activator: _withCtx(({
            props
          }) => [_createVNode(_component_v_row, {
            justify: "center"
          }, {
            default: _withCtx(() => [_createVNode(_component_v_icon, _mergeProps({
              ref_for: true
            }, props), {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createTextVNode("mdi-dots-horizontal", -1)]))]),
              _: 1
            }, 16)]),
            _: 2
          }, 1024)]),
          default: _withCtx(() => [_createVNode(_component_v_list, null, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, index) => {
              return _openBlock(), _createBlock(_component_v_list_item, {
                key: index,
                value: index
              }, {
                default: _withCtx(() => [_createVNode(_component_v_list_item_title, {
                  "data-cy": "invoice-template-action",
                  onClick: _withModifiers($event => _ctx.$emit('handleActionButtonClicked', item.id, invoiceTemplate.invoiceTemplateId, invoiceTemplate), ["prevent"])
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(item.title), 1)]),
                  _: 2
                }, 1032, ["onClick"])]),
                _: 2
              }, 1032, ["value"]);
            }), 128))]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1024)])]);
      }), 128))])])])])]);
    };
  }
};